import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function District({districtFilter,setDistrictFilter}) {
  const handleChange = (event) => {
    setDistrictFilter(event.target.value);
  };

  return (
    <Box sx={{ width: 200 }}  marginLeft={1}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">District</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={districtFilter}
          label="District"
          onChange={handleChange}
        >
          <MenuItem value={'All'}>All</MenuItem>
          <MenuItem value={'BHV'}>Bahawalpur</MenuItem>
          <MenuItem value={'DGK'}>Dera Gazi Khan</MenuItem>
          <MenuItem value={'FSD'}>Faislabad</MenuItem>
          <MenuItem value={'GRW'}>Gujranwala</MenuItem>
          <MenuItem value={'LHR'}>Lahore</MenuItem>
          <MenuItem value={'MUL'}>Multan</MenuItem>
          <MenuItem value={'RWP'}>Rawalpindi</MenuItem>
          <MenuItem value={'SWH'}>Sahiwal</MenuItem>
          <MenuItem value={'SGD'}>Sarghoda</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}